import { formatDateTimeReadable, LoanCriteria } from '@nemuru-eng/js-api-client';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useUser } from '@/hooks/useUser';

export const updatedAtWithBorrowerNameFieldColumnMobile = ({ flex }: { flex?: number }) => {
  const { palette } = useCustomTheme();

  const { userEntity } = useUser();

  const showMerchant = userEntity && !userEntity.isRoleMerchantChannelOrAgent();

  return {
    flex: flex ?? 0.6,
    field: 'updated_at',
    headerName: <Text tId={'UPDATE_DATE'} />,
    align: 'left',
    searchable: false,
    defaultSort: 'desc',
    renderCell: (rowData: { row: LoanCriteria }) => {
      return (
        <div className={'overflow-text-ellipsis'}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Font color="textPrimary" variant="caption" style={{ lineHeight: '1.43rem' }}>
              <strong>{formatDateTimeReadable(rowData.row.updatedAt)}</strong>
            </Font>
          </div>
          <span style={{ color: palette.text.secondary }}>
            {`${rowData.row.borrowerInvitation.fullName.firstName} ${rowData.row.borrowerInvitation.fullName.lastName}`}
          </span>
          <div className={'overflow-text-ellipsis'}>
            <Font color="textSecondary" variant={'caption'}>
              {showMerchant ? rowData.row.businessName : rowData.row.agentName}
            </Font>
          </div>
        </div>
      );
    },
  };
};
